import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popup } from '_atoms';
import { Typography } from '_atoms/Typography';
import './style.scss';

interface PopupRegenerateCandidateSummaryProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const PopupRegenerateCandidateSummary: React.FC<PopupRegenerateCandidateSummaryProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Popup
      className="popup-regenerate-candidate-summary"
      open={open}
      title={t('translation:job_candidate_summary.regenerate_title')}
      onClose={onClose}
      cancelButtonProps={{
        onClick: onClose,
        children: t('translation:job_candidate_summary.action_cancel'),
        variant: 'grey',
      }}
      okButtonProps={{
        children: t('translation:job_candidate_summary.action_regenerate'),
        onClick: onConfirm,
      }}
    >
      <Typography.Text className="popup-regenerate-candidate-summary__text">
        {t('translation:job_candidate_summary.regenerate_message')}
      </Typography.Text>
    </Popup>
  );
};
